import { PatentSearchFilterType } from "@/components/business/PatentContainer/patentList.types";

export const PATENT_LIST_EDITOR_INFO_FILTER: PatentSearchFilterType[] =
  [
    {
      key: "allEditorInfo",
      name: "All Editor",
      isAllInfo: true,
    },
    {
      key: "mcEditorInfo",
      name: "MC Editor",
      code: "S112",
      isAllInfo: false,
    },
    {
      key: "ftEditorInfo",
      name: "FT Editor",
      code: "S911",
      isAllInfo: false,
    },
  ];

export const PATENT_LIST_EDITOR_INFO_FILTER_KEY = [
  "allEditorInfo",
  "mcEditorInfo",
  "ftEditorInfo",
] as const;
